<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
      <!-- alert message -->
      <div>
        <v-alert :type="alert_type" :model-value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
      </div>
      <!-- alert message end -->
      <!-- header -->
      <div>
        <HeaderComponent :headerTitle="headerText" />
      </div>
      <!-- header end -->
      <!-- action buttons and search -->
      <v-card-title style="padding: 25px 25px 15px 15px;" class="action-style pb-1">
        <v-row class="ma-1">
          <!-- search type -->
          <v-autocomplete color="primary" class="mr-4" v-model="field_type" :items="Array.isArray(field_item) ? field_item : []" item-value="value" style="max-width: 150px;" item-title="name" label="Select Field" variant="outlined"></v-autocomplete >
          <!--search field  -->
          <v-text-field color="primary" prepend-inner-icon="mdi-magnify"  v-model="inward_search" v-no-edge-space label="Search" style="max-width: 300px;" variant="outlined" v-on:keyup.enter="getData()"></v-text-field>
          <v-spacer></v-spacer> 
          <!-- action buttons -->
          <v-card-actions style="margin-bottom: 18px; padding-top: 0px; padding-bottom: 0px;">
            <v-btn class="mr-2 text-none" size="x-large"  variant="flat" color="primary" :disabled="this.selected.length == 0 || number > 0" @click="confirmPopupOpen" v-if="isActionAllowed(role)">{{organization_name === 'Voltas' || ($isRelianceClient() || organization_name === 'Clicktech') ? 'Generate GRN' : 'Download'}}</v-btn>
            <v-btn class="mr-2 text-none" size="x-large"  variant="flat" color="primary" :disabled="($isRelianceClient() || organization_name === 'Clicktech') ? true : false" v-if="isActionAllowed(role)" @click="navigateToFileUpload">Upload</v-btn>
            <v-btn class="mr-2 text-none" size="x-large"  variant="flat" v-if="organization_name !== 'Voltas' && (!$isRelianceClient() && organization_name !== 'Clicktech' ) && isActionAllowed(role)" color="this.selected.length == 0 ? '' : 'primary'" 
            @click="generateGrn" :disabled="(this.selected.length == 0) || number > 0">Generate GRN</v-btn>
          </v-card-actions>
        </v-row>
      </v-card-title>
      <!-- action buttons and search end -->
      <!-- table  -->
      <v-layout column>
        <v-col cols="12" style="overflow: auto" class="p-0 table-style-size">
          <v-data-table
            hover
            density="compact"
            :search="search"
            v-model="selected"
            show-select
            disable-pagination
            :hide-default-footer="true"
            :headers="headers"
            :items="table_data"
            fixed-header
            height="100%"
            :loading="loading"
            :items-per-page="pageSize"
            loading-text="Loading Data... Please wait"
            class="elevation-1" 
            return-object
            :dense="true"
            >
            <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">              
              <span v-if="header.key == 'inward_reference_document_number'">
                  <a @click="IrdDetails(item)" style="color: #1976d2;" class="cursor-pointer">
                    <u> {{ item.inward_reference_document_number }}</u>
                  </a>              
                </span> 
                <span v-else-if="header.key == 'qty_not_inwarded'">
                  <a @click="itemDetails(item)" style="color: #1976d2;" class="cursor-pointer">
                    <u> {{ item.qty_not_inwarded }}</u>
                  </a>              
                </span> 
                <span v-else-if="item[header.key]">
                  <GlobalTooltip :text="item[header.key]" />
                </span>
                <span v-else>-</span>
            </template> 
            <!-- <template   #[`item.qty_not_inwarded`]="{ item }">
              <a @click="itemDetails(item)" style="color: #1976d2;" class="cursor-pointer">
                <u> {{ item.qty_not_inwarded }}</u>
              </a>
            </template>
            <template   #[`item.inward_reference_document_number`]="{ item }">
              <a @click="IrdDetails(item)" style="color: #1976d2;" class="cursor-pointer">
                <u> {{ item.inward_reference_document_number }}</u>
              </a>
            </template> -->
            <template #bottom></template>
            </v-data-table> 
        </v-col>
      </v-layout>
      <!-- table end -->
      <!-- pagination display -->
      <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    :handlePageSizeChange="handlePageSizeChange"
                    :handlePageChange = "handlePageChange"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-2"
                />
      <!-- popups -->
      <v-row justify="center">
        <v-dialog v-model="viewDetailsPopup" persistent max-width="800px">
          <v-card class="v-card-100">
              <v-card-title class="d-flex align-center">
                <span>Items Not Inwarded</span>
                <v-spacer></v-spacer>
                <v-btn variant="solo" icon @click="viewDetailsPopup = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                  <v-data-table
                  hover
                  density="compact"
                  :search="search"
                  v-model="ItemSelected"
                  :headers="viewDetailsHeader"
                  :items="view_details"
                  :loading="loading"
                  height="400px"
                  :items-per-page="pageSize"
                  loading-text="Loading Data... Please wait"
                  class="elevation-1" >
                  <template #[`item.box_number`]="{ item }">
                    {{ item.box_number || 'N/A' }}
                  </template>
                  <template #[`item.tag_number`]="{ item }">
                    {{ item.tag_number || 'N/A' }}
                  </template>
                  <template #[`item.inward_reference_document_number`]>
                    {{  Item_Ird || 'N/A' }}
                  </template>
                  </v-data-table> 
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- ird Details Popup -->
      <v-row justify="center">
        <v-dialog v-model="IrdDetailsPopup" persistent max-width="700px">
          <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span class="ml-4">{{ IrdNo }}</span>
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="IrdDetailsPopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thikness="4" class="m-0" />
            <v-card-text>
              <v-container>
                <div class="itemPopUp">
                  <!-- <v-row>
                    <v-col cols="6">
                      <span style="font-weight: 500;">Created At</span>
                    </v-col>
                    <v-col cols="6">
                      {{ item_details_popup.created_at ? item_details_popup.created_at : 'N/A'}}
                    </v-col>
                  </v-row> -->
                  <v-row>
                    <v-col cols="6" >
                      <span style="font-weight: 500;">Quantity</span>
                    </v-col>
                    <v-col cols="6">
                      {{ item_details_popup.quantity ? item_details_popup.quantity : 'N/A'}}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" >
                      <span style="font-weight: 500;">Quantity Inwarded</span>
                    </v-col>
                    <v-col cols="6">
                      {{ item_details_popup.qty_inwarded }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" >
                      <span style="font-weight: 500;">Quantity Not Inwarded</span>
                    </v-col>
                    <v-col cols="6">
                      {{ item_details_popup.qty_not_inwarded ? item_details_popup.qty_not_inwarded : 'N/A'}}
                    </v-col>
                  </v-row>
                  <!-- <v-row>
                    <v-col cols="6">
                      <span style="font-weight: 500;">Inward Reason Reference Document Type</span>
                    </v-col>
                    <v-col cols="6">
                      {{ popup_item_info.inward_reason_reference_document_type ? popup_item_info.inward_reason_reference_document_type : 'N/A'}}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" >
                      <span style="font-weight: 500;">Inward Reason Reference Document Number</span>
                    </v-col>
                    <v-col cols="6">
                      {{ popup_item_info.inward_reason_reference_document_number ? popup_item_info.inward_reason_reference_document_number : 'N/A'}}
                    </v-col>
                  </v-row> -->
                  <v-row>
                    <v-col cols="6" >
                      <span style="font-weight: 500;">Consignee Reference Document Number</span>
                    </v-col>
                    <v-col cols="6">
                      {{ popup_item_info.consignee_reference_document_number ? popup_item_info.consignee_reference_document_number : 'N/A'}}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" >
                      <span style="font-weight: 500;">Vendor Reference Document Number</span>
                    </v-col>
                    <v-col cols="6">
                      {{ popup_item_info.vendor_reference_document_number ? popup_item_info.vendor_reference_document_number : 'N/A'}}
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row justify="center">
          <v-dialog v-model="successPopup" persistent max-width="424px">
          <v-card class="v-card-100 pa-2">
              <v-card-title>
                  <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text class="text-center">
                   <span > {{message}} </span>
              </v-card-text>
              <v-card-actions center>
                  <v-spacer></v-spacer>
                  <v-btn color="white" class="mb-3 bg-blue text-none" @click="closePopup">Ok</v-btn>
                  <v-spacer></v-spacer>
              </v-card-actions>
          </v-card>
          </v-dialog>
      </v-row>
      <v-row justify="center">
          <v-dialog v-model="warningPopup" persistent max-width="424px">
          <v-card class="v-card-100 pa-2">
              <v-card-title>
                  <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text class="text-center">
                  <div><span><v-icon color="red" class="icon-size">mdi-alert</v-icon></span></div>
                  <span > {{message}} </span>
              </v-card-text>
              <v-card-actions center>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="warningPopup = false">NO</v-btn>
                  <v-btn color="primary" variant="flat" class="mb-3 text-none" :disabled="number > 0" @click="ProceedItems">yes</v-btn>
                  <v-spacer></v-spacer>
              </v-card-actions>
          </v-card>
          </v-dialog>
      </v-row>
      <v-row justify="center">
          <v-dialog v-model="generateConfirmPopup" persistent max-width="424px">
          <v-card class="v-card-100 pa-2">
              <v-card-title>
                  <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text class="text-center">
                  <span > Do you want to Generate GRN with short item/s ? </span>
              </v-card-text>
              <v-card-actions center>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="generateConfirmPopup = false">Cancel</v-btn>
                  <v-btn color="primary"  variant="flat"class="mb-3 text-none" :disabled="number > 0" @click="downloadInventory">Confirm</v-btn>
                  <v-spacer></v-spacer>
              </v-card-actions>
          </v-card>
          </v-dialog>
      </v-row>
    </v-card>
  </template>
  <script>
    import HeaderComponent from "../../../commoncomponents/HeaderComponent.vue";
    import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
    // import 'vue-loading-overlay/dist/vue-loading.css';
    import 'vue-loading-overlay/dist/css/index.css';
     import { isOnlyViewAction } from '@/backend/axios/moduleAccess'

    export default {
      data() {
        return {
          headerText: "Inward Tracking",
          alert: false,
          alert_type: "success",
          alert_message: "success",
          headers: [
            { title: "IRD No.", key: "inward_reference_document_number", sortable: false },
            { title: "Quantity", key: "quantity" },
            { title: "Quantity Inwarded", key: "qty_inwarded" },
            { title: "Quantity Not Inwarded", key: "qty_not_inwarded" },
          ],
          viewDetailsHeader:[
            { title: "IRD No.", key: "inward_reference_document_number", sortable: false },
            { title: "Box ID", key: "box_number" },
            { title: "Tag ID", key: "tag_number" },
            { title: "Article ID", key: "sku_code" },
            { title: "Article Description", key: "sku_description" },
            { title: "Qty", key: "quantity" },
          ],
          inward_search:'',
          field_type:[],
          field_item:[
          { key: 1, name: 'IRD No' },
          ],
          selected: [],
          search:'',
          table_data:[],
          loading: false,
          page: 1,
          totalPages: [],
          totalCount: '',
          pageSize: defaultPageSize,
          pageSizes: defaultPageSizes,
          viewDetailsPopup: false,
          view_details:[],
          ItemSelected:[],
          IrdDetailsPopup: false,
          IrdNo:'',
          successPopup: false,
          message:'',
          warningPopup : false,
          item_details_popup:'',
          popup_item_info:'',
          initialWindowHeight: window.innerHeight,
          number: 0,
          organization_name:'',
          role:'',
          generateConfirmPopup:false,
        }
      },
      components: {
        HeaderComponent
      },
      mounted() {
        this.field_type = this.field_item.length > 0 ? this.field_item[0].value : null;
      },
      created() {
        this.role = this.$store.state.currentUser.roles[0]
        this.organization_name = this.$store.state.organization_name
        this.loadData();
      },
      methods: {
        isActionAllowed(){
          return !isOnlyViewAction(this.role, 'Inwarding')
        },
        loadData() {
          this.inward_search = ''
          this.field_type = null
          this.table_data = []
          this.page = 1
          this.totalPages = 1
          this.getData();
        },
        getData(){
          this.loading = true;
          this.selected = [];
          const requestBody = {
            search: this.inward_search,
            page: this.page,
            per_page: this.pageSize
          };
          this.$httpSecured
            .get('/api/v1/warehouse/inward_tracking', {params: requestBody})
            .then(response => {
                if (response.data) {
                  this.table_data = response.data.data;
                  this.table_data.forEach((item,index)=>{
                    item.id = index+1
                  })
                  this.totalPages = response.data.meta.total_pages;
                  this.totalCount = response.data.meta.total_count;
                  this.loading = false;
                } else {
                  this.showAlert("error", "No Data Found");
                  this.loading = false;
                }
            })
            .catch(error => {
                this.showAlert("error", "Something went wrong from Network" + error);
                this.loading = false;
            });
        },
        IrdDetails(item){
          this.item_details_popup = item
          this.IrdDetailsPopup = true;
          this.ids = item.inward_reference_document_number;
          this.IrdNo = item.inward_reference_document_number
          // this.getData();
          this.ItemAPi();
        },
        itemDetails(item) {
          this.viewDetailsPopup = true;
          this.ids = item.inward_reference_document_number;
          this.Item_Ird = item.inward_reference_document_number;
          this.ItemAPi();
        },
        ItemAPi(){
          this.$httpSecured
          .get(`/api/v1/warehouse/inward_tracking/${this.ids}`)
          .then(response => {
            if (response.data) {
              this.view_details = response.data.prd.pending_inward_items;
              this.popup_item_info = response.data.prd
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");              
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        },
        generateGrn(){
          this.number++;
          const item_Ids = this.selected.map(x=> x.id);
          var dc = this.selected.map(x => x.qty_not_inwarded)
                  const unique = (value, index, self) => {
                      return self.indexOf(value) === index
                  }
                  dc = dc.filter(function (element) {
                      return element !== undefined;
                  });
              var unique_array = dc.filter(unique)
              if (unique_array == 0) {  
                this.$httpSecured
                  .post("/api/v1/warehouse/inward_tracking/generate_grn", { "ids" : item_Ids} )
                      .then(response => {
                      if (response.data) {
                          this.message = response.data.message;
                          this.selected = []
                          this.successPopup = true;
                          this.number = 0;
                      } else {
                          this.showAlert("error", "No Data Found");
                          this.number = 0;
                      }
                  })
                      .catch(error => {
                          this.$toast.error(error.response.data.error)
                          this.number = 0;
                  });
              }else if(unique_array != 0){
                this.warningPopup = true;
                this.number = 0;
                this.message = "Warning: Some items have not been inwarded and will be marked as short. Continue to generate GRN?"
              }
        },
        ProceedItems(){
          this.number ++
          const item_Ids = this.selected.map(x=> x.id);
          this.$httpSecured
            .post("/api/v1/warehouse/inward_tracking/generate_grn", { "ids" : item_Ids} )
              .then(response => {
                if (response.data) {
                  this.message = response.data.message;
                  this.warningPopup = false;
                  this.selected = []
                  this.successPopup = true;
                } else {
                    this.showAlert("error", "No Data Found");
                }
            })
              .catch(error => {
                this.$toast.error(error.response.data.error)
            });
        },
        closePopup(){
          this.successPopup = false;
          this.loadData();
        },
        handlePageSizeChange(size){
          this.pageSize = size;
          this.page = 1
          this.getData();    
        },
        handlePageChange(value) {
          this.page = value;
          this.getData();
        },
        navigateToFileUpload() {
          this.$store.commit("setLotIds", {
            lotIds: "inward_tracking",
            inventoryId: "Inward Tracking"
          });
          this.$router.push({ name: "LotFileuploadComm" });
        },
        downloadInventory() {
          this.number++;
          let ids = this.selected.map(inward => inward.inward_reference_document_number);
          if(this.$isRelianceClient() || this.organization_name === 'Clicktech'){
            this.$httpSecured.post(`/api/v1/warehouse/inward_tracking/generate_grn`,{
            'ids': ids
          })
          .then(response => {
            if (response.data) {
              // this.showAlert("success", "Successfully Generate GRN updated")
              this.showAlert("success", response.data.message)
              this.generateConfirmPopup = false;
              this.number = 0;
              this.loadData();
              this.selected = [];
            } else {
                this.showAlert("error", "No Data Found");
                this.number = 0;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
            this.number = 0;
          });
        }else{
          this.$httpSecured.post(`/api/v1/warehouse/inward_tracking/get_csv_file`,{
            'prd_ids': ids
          })
            .then(response => {
              const link = document.createElement('a');
              link.href = response.data.url; 
              link.target = '_blank';
              link.download = 'inventory.csv'; 
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.number = 0;
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
              this.number = 0;
            });
          }
        },
        showAlert(alert_type, alert_message) {
            this.alert = true;
            this.alert_type = alert_type;
            this.alert_message = alert_message;
            this.alertTimeOut();
          },
          alertTimeOut() {
            setTimeout(() => {
              this.alert = false;
            }, 3000);
          },
          confirmPopupOpen(){
          this.generateConfirmPopup = true;
        } 
      },
    }
  </script>
  <style scoped>
    .icon-size{
      font-size: 40px !important;
      margin-bottom: 20px;
    }
    .item-selected{
          margin-top: 23px;
          position: absolute;
          left: 41%;
      }
      @media (max-height: 1104px) {
          .PaddingItemPerPage{
              padding: 8px !important;
          }
      }
      @media (min-height: 1126px) {
          .PaddingItemPerPage{
              padding: 24px !important;
          }
      }
      :deep(.table-style-size .v-data-table) {
      height: calc(var(--vh, 1vh) * 100 - 270px) !important;
    }
  </style>
